import { render } from "./TailwindTable.vue?vue&type=template&id=014a0837&scoped=true"
import script from "./TailwindTable.vue?vue&type=script&lang=js"
export * from "./TailwindTable.vue?vue&type=script&lang=js"

import "./TailwindTable.vue?vue&type=style&index=0&id=014a0837&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-014a0837"]])

export default __exports__